import React, { useCallback } from 'react';
import { TextFieldChip } from 'modules/common';
import { TimesheetLabel } from 'modules/timesheet-labels/labelSchema';
import { LabelValue } from 'graphql/types';

type SelectChipProps = {
  label: TimesheetLabel;
  onChange: (value: LabelValue | null) => void;
};
export const TextChip: React.FC<SelectChipProps> = ({
  label,
  onChange
}: SelectChipProps) => {
  const handleDelete = useCallback(() => {
    onChange(null);
  }, [onChange]);
  const acceptSuggestionHandler = useCallback(
    (value: LabelValue) => onChange(value),
    [onChange]
  );

  return (
    <div data-testid={'text-chip'}>
      <TextFieldChip
        label={label}
        onChange={onChange}
        type={'text'}
        handleDelete={handleDelete}
        acceptSuggestion={acceptSuggestionHandler}
      />
    </div>
  );
};
